import { EqipFarmInformationTaskEditor } from './EqipFarmInformationTaskEditor'

export const EqipFarmInformationDetailFeatureMap = {
  Component: {
    traitId: 'eqipFarmInformation' as const,
    TaskEditor: EqipFarmInformationTaskEditor,
  },
  resourceType: 'workflow' as const,
}
